import organisationsChangelog from "../../../../../pages/organisations/docs/changelog-organisations.json5";
import * as React from 'react';
export default {
  organisationsChangelog,
  React
};